export const recommendations = {
  namespaced: true,
  state: {
    recommendations: {},
  },
  getters: {
    recommendations(state) {
      return state.recommendations;
    },
  },
  mutations: {
    setRecommendations(state, info) {
      state.recommendations = info;
    },
  },
  actions: {
    // オススメを緯度経度から取得
    async getRecommendations(context, { geo }) {
      var params = {};
      console.log("context.dispatch :>> ", context);
      const resp = await context.dispatch(
        "common/getRequest",
        {
          path: `search-recommends?geo_point=${geo}`,
          bodyParams: params,
        },
        { root: true }
      );
      console.log(
        "getRecommendations resp.data.locations[0]) :>> ",
        resp.data.locations[0]
      );
      return resp.data.locations[0];
    },
  },
};
